<div id="enrollment-agreement">
  <div class="page1 p-3">

    <h3 class="text-center fw-bold mb-3">Student Enrolment Agreement</h3>

    <!-- Student Information -->
    <div class="d-flex border-bottom pb-1 mb-1">
      <span class="fw-bold me-2" style="white-space:nowrap;">Student:</span>
      <div class="d-flex flex-grow-1 gap-3">
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">First name</small>
          <span>{{ primaryContact?.field_first_name || entityData?.['field_student']?.['title']?.split(' ')[0] || '' }}</span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Last Name</small>
          <span>{{ primaryContact?.field_last_name || entityData?.['field_student']?.['title']?.split(' ').slice(1).join(' ') || '' }}</span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Street Address</small>
          <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex gap-4 border-bottom pb-1 mb-2">
      <div>
        <span class="fw-bold me-1">City:</span>
        <span>{{ primaryContact?.field_address?.locality || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">Province:</span>
        <span>{{ primaryContact?.field_address?.administrative_area || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">Postal Code:</span>
        <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Tel.</span>
        <span>{{ primaryContact?.field_cell_phone || '' }}</span>
      </div>
    </div>

    <p class="small mb-2">The Student agrees to purchase and the owner of the Arthur Murray Franchised Dance School agrees to provide the following course of dance instruction and/or services on the following items and conditions including the terms and conditions of this agreement. All sessions of 45 minutes duration with 40 minutes of full instruction and 5 minute break inclusive.</p>

    <div class="row mb-2">
      <div class="col-9">
        <p class="small fst-italic mb-2">The expiry date of this agreement is <span class="fw-bold border-bottom px-2">{{ expirationDate ? (expirationDate | date) : '____________' }}</span></p>

        <!-- Lesson table -->
        <table class="table table-bordered text-center small mb-2">
          <tr>
            <td class="fw-bold">Private Lessons</td>
            <td class="fw-bold">Group Lessons</td>
            <td class="fw-bold">Practice Party</td>
            <td class="fw-bold">Tuition</td>
            <td class="fw-bold">Discount</td>
            <td class="fw-bold">{{ taxLabel }}</td>
            <td class="fw-bold">Balance Due</td>
          </tr>
          <tr>
            <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
            <td></td>
            <td></td>
            <td>${{ getOriginalPackageCost() | number:'1.2-2' }}</td>
            <td>${{ getDiscount() | number:'1.2-2' }}</td>
            <td>${{ getHstAmount() | number:'1.2-2' }}</td>
            <td>${{ calculateTotalTuition() | number:'1.2-2' }}</td>
          </tr>
        </table>

        <table class="table table-bordered small mb-2">
          <tr>
            <td class="fw-bold text-center">Type of service(s)</td>
            <td class="fw-bold text-center" style="width:25%">Tuition</td>
          </tr>
          <tr>
            <td>{{ getPackageName() }}<span *ngIf="getNotes()" class="d-block fst-italic">{{ getNotes() }}</span></td>
            <td>${{ getSubtotal() | number:'1.2-2' }}</td>
          </tr>
        </table>
      </div>
      <div class="col-3">
        <div class="border border-dark p-2 small">
          <p class="fw-bold mb-1">Type of Enrolment:</p>
          <p class="mb-0"><span class="border border-dark d-inline-block me-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.pre_original ? '#000' : '#fff'"></span> Pre-Original</p>
          <p class="mb-0"><span class="border border-dark d-inline-block me-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span> Original</p>
          <p class="mb-0"><span class="border border-dark d-inline-block me-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span> Extension</p>
          <p class="mb-0"><span class="border border-dark d-inline-block me-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span> Renewal</p>
          <p class="mb-0"><span class="border border-dark d-inline-block me-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.service ? '#000' : '#fff'"></span> Service</p>
        </div>
      </div>
    </div>

    <!-- Acknowledgment + balance -->
    <p class="small mb-1">The student acknowledges a total balance of <span class="border-bottom px-3 fw-bold">${{ calculateTotalTuition() | number:'1.2-2' }}</span> for the instruction and/or service(s) described above and agrees to pay <span class="border-bottom px-3 fw-bold">${{ getDownPaymentAmount() | number:'1.2-2' }}</span> today and the balance as follow:</p>

    <div *ngIf="isInstallmentAgreement && allPaymentRows.length" class="mb-3" style="max-width:420px;">
      <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedPayments">
        <table class="table table-bordered text-center small mb-1">
          <tr>
            <th>Number of Payments</th>
            <th>Amount of Payments</th>
            <th>Payments Due</th>
          </tr>
          <tr>
            <td>{{ allPaymentRows.length }}</td>
            <td>${{ allPaymentRows[0].amount | number:'1.2-2' }}</td>
            <td>{{ firstPaymentDate ? (firstPaymentDate | date) : 'Not specified' }}</td>
          </tr>
        </table>
      </ng-container>
      <ng-template #detailedPayments>
        <table class="table table-bordered text-center small mb-1">
          <tr>
            <th>Payment #</th>
            <th>Amount</th>
            <th>Due Date</th>
          </tr>
          <tr *ngFor="let payment of allPaymentRows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>${{ payment.amount | number:'1.2-2' }}</td>
            <td>{{ payment.date ? (payment.date | date) : '' }}</td>
          </tr>
        </table>
      </ng-template>
      <p class="small mb-0">Payments due as scheduled above, until paid in full.</p>
    </div>

    <!-- Studio box + signatures -->
    <div class="row mt-2">
      <div class="col-6">
        <div class="border border-dark p-2 text-center small mb-2">
          <p class="fw-bold mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || this.studioInformationConfig?.field_studio_display_name?.[0]?.value || '' }}</p>
          <p class="mb-0" *ngIf="this.studioInformationConfig?.field_studio_address?.[0]?.organization">d/b/a An Arthur Murray Franchised Dance Studio</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }}</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}</p>
          <p class="mb-0">Tel: {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}</p>
        </div>
        <ng-container *ngIf="displaySigned">
          <p class="small mb-0">By:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <small class="text-muted">Studio Representative</small>
        </ng-container>
      </div>
      <div class="col-6" *ngIf="displaySigned">
        <p class="small mb-2">Signed this <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        <p class="small fw-bold mb-0">THE STUDENT HEREBY ACKNOWLEDGES THAT:</p>
        <p class="small mb-2">(1) (S)he has read the terms and conditions on the reverse side of this agreement; and (2) they form part of this agreement.</p>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
        <small class="text-muted">Student's Signature</small>
      </div>
    </div>

  </div>

  <!-- The School's/Student's Rights and Obligations back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
